// Component: ScrollImage. Props: standard image info.
//
// This renders an image in a scrolling list, using the image info passed
// in.
//
// See also: latestStore.getImageKey to construct a Reac Key that will make
// sure the ScrollImage is correctly recognized by React in the scrolling list,
// even when updates to the context (window width, thumbnail size) are made.

import { useState } from "react";

import FullImage from "./FullImage";

function ScrollImage(props) {
  const {imageInfo} = props;
  const {url, description, calcWidth, calcHeight, margin, onClick} = imageInfo;

  const [showFull, setShowFull] = useState(false);

  const style = {
    width: '' + calcWidth + 'px',
    height: '' + calcHeight + 'px'
  }
  if (margin) {
    // Implement the margin through a top and bottom border
    style.borderTop = 'solid ' + margin + 'px #ccc';
    style.borderBottom = 'solid ' + margin + 'px #ccc';
  }
  if (onClick) {
    style.cursor = 'pointer';
  }

  // const className = index ? 'scroll-image next' : 'scroll-image first';
  const className = 'scroll-image next';

  const title = description ? description : 'Image';

  return (
    <>
      <img
        alt='thumbnail'
        className={className}
        onClick={() => setShowFull(true)}
        src={url}
        style={style}
        title={title}
      />
      {
        showFull &&
        <FullImage
          imageInfo={imageInfo}
          onClose={() => setShowFull(false)}
        />
      }
    </>
  );

}

export default ScrollImage;
